import Moment from 'react-moment';
import { HtmlPlaceholderFormatter } from '../../Atoms/Formatter/HtmlPlaceholderFormatter';

const EmailHistoryListItem = ({ email, onClick, active, customer, event }) => {
  if (!email) {
    return null;
  }

  const styles = {
    item: {
      paddingTop: 5,
      paddingBottom: 5,
      paddingLeft: 15,
      paddingRight: 5,
      marginBottom: 5,

      backgroundColor: active ? 'rgba(0, 0, 0, .03)' : null,
      borderLeft: email.localDateTime && !email.readTimestamp && !email.sendByUser ? '4px solid #698aa6' : 'unset',
      borderBottom: 'solid 2px #e5e5e5',
    },
    subject: {
      marginRight: 5,
      color: email.localDateTime && !email.readTimestamp && !email.sendByUser ? '#698aa6' : '#969696',
      fontWeight: email.localDateTime && !email.readTimestamp && !email.sendByUser ? 800 : 'unset',
      maxWidth: 200,
    },
    messagePreview: {
      marginRight: 5,
      color: '#969696',
      maxWidth: 200,
    },
    eventDescription: {
      textAlign: 'right',
      color: '#969696',
      paddingRight: 0,
      paddingLeft: 0,
      display: 'flex',
      height: 21,
      flexDirection: 'column',
    },
    sendTimeStamp: {
      minWidth: 80,
      fontSize: '0.75rem',
      color: '#969696',
    },
    date: {
      display: 'flex',
      alignSelf: 'flex-end',
      marginLeft: 4,
      textAlign: 'right',
      fontSize: 10,
    },
    row: {
      display: 'flex',
      justifyContent: 'space-between',
    },
    firstRow: {
      display: 'flex',
      fontWeight: email.localDateTime && !email.readTimestamp && !email.sendByUser ? 800 : 'unset',
    },
    addEventRelation: {
      textAlign: 'right',
      paddingRight: 0,
      paddingLeft: 0,
    },
  };

  const calendarStrings = {
    lastDay: '[Gestern, ] LT',
    sameDay: '[Heute, ] LT',
    nextDay: '[Morgen, ] LT',
    lastWeek: 'dd[,] LT',
    sameElse: 'L',
  };

  {
    /*
    {event ? <Button style={styles.eventDescription} color="link" onClick={() => {history.push("/events/" + event.id)}}><span style={{alignSelf: "flex-end"}}>{getKind(event) + " am:"}</span><Moment style={styles.date} format={"L"}>{event.dates[0].date}</Moment> </Button>
                        : ""}
                    {!event ? <TransButtonLink style={styles.addEventRelation} onClick={toggle} text={"Event zuweisen"}/> : null}
    */
  }

  let contact = email.sendByUser ? (email.to && email.to.length > 0 ? email.to[0] : {}) : email.from;
  if (!contact) contact = {};
  const messagePreview = email.message ? email.message.replace(/<[^>]*>?/gm, '') : null;
  return (
    <div style={styles.item} className="clickable" onClick={onClick}>
      <div style={styles.row}>
        <div style={styles.firstRow}>{contact.personDescription ? contact.personDescription : contact.email}</div>
      </div>

      <div style={styles.row}>
        <div className="overflow-ellipsis" style={styles.subject}>
          <HtmlPlaceholderFormatter label value={email.subject} event={event} customer={customer} />
        </div>

        {!email.scheduledTime && (
          <div style={styles.eventDescription} onClick={() => {}}>
            {email.localDateTime && (
              <Moment style={styles.date} calendar={calendarStrings}>
                {email.localDateTime}
              </Moment>
            )}
            {!email.localDateTime && (
              <Moment style={styles.date} calendar={calendarStrings}>
                {email.lastModified}
              </Moment>
            )}
          </div>
        )}
        {email.scheduledTime && (
          <div style={styles.eventDescription} onClick={() => {}}>
            <Moment fromNow style={styles.date} calendar={calendarStrings}>
              {email.scheduledTime}
            </Moment>
          </div>
        )}
      </div>
      <div style={styles.row}>
        <div className="overflow-ellipsis" style={styles.messagePreview}>
          <HtmlPlaceholderFormatter label value={messagePreview} event={event} customer={customer} />
        </div>
      </div>
    </div>
  );
};

export default EmailHistoryListItem;
